var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildCustomWidget({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "977CAFA8-DDE9-4C86-AE40-DC52B1A8EE02") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/BuildCustomWidget",
    fill: "#C0C6CC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashed-Line",
    transform: "translate(10.000000, 10.000400)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "19 20 20 20 20 19 19 19"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "17 20 18 20 18 19 17 19"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "15 20 16 20 16 19 15 19"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "4 20 5 20 5 19 4 19"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "2 20 3 20 3 19 2 19"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    points: "0 20 1 20 1 19 0 19"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 3 1 3 1 2 0 2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 5 1 5 1 4 0 4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 16 1 16 1 15 0 15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 18 1 18 1 16.999 0 16.999"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    points: "0 1 1 1 1 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "17 1 18 1 18 0 17 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "15 1 16 1 16 0 15 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "4 1 5 1 5 0 4 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "2 1 3 1 3 0 2 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    points: "19 1 20 1 20 0 19 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "19 3 20 3 20 2 19 2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "19 5 20 5 20 4 19 4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "19 16 20 16 20 15 19 15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "19 18 20 18 20 16.999 19 16.999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pencil-Wrench",
    transform: "translate(4.525000, 2.254400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.95,20.246 L28.95,20.246 L28.95,15.246 L26.95,15.246 L26.95,20.246 Z M25.95,20.246 L17.975,20.246 L17.975,19.746 L17.975,15.246 L25.95,15.246 L25.95,20.246 Z M15.475,8.746 C13.269,8.746 11.475,6.952 11.475,4.746 C11.475,3.491 12.068,2.383 12.975,1.649 L12.975,4.746 L17.975,4.746 L17.975,1.649 C18.882,2.383 19.475,3.491 19.475,4.746 C19.475,6.952 17.681,8.746 15.475,8.746 L15.475,8.746 Z M13.975,26 L13.975,20.746 L13.975,19.746 L13.975,14.746 L13.975,13.746 L13.975,9.492 C14.451,9.642 14.949,9.746 15.475,9.746 C16.001,9.746 16.499,9.642 16.975,9.492 L16.975,13.746 L16.975,14.746 L16.975,19.746 L16.975,20.746 L16.975,26 C16.499,25.85 16.001,25.746 15.475,25.746 C14.949,25.746 14.451,25.85 13.975,26 L13.975,26 Z M19.475,30.746 C19.475,32.001 18.882,33.109 17.975,33.843 L17.975,30.746 L12.975,30.746 L12.975,33.843 C12.068,33.109 11.475,32.001 11.475,30.746 C11.475,28.54 13.269,26.746 15.475,26.746 C17.681,26.746 19.475,28.54 19.475,30.746 L19.475,30.746 Z M5.45,20.246 L5.45,15.246 L12.975,15.246 L12.975,19.746 L12.975,20.246 L5.45,20.246 Z M4.45,19.668 L3.95,19.314 L1.732,17.746 L3.95,16.178 L4.45,15.824 L4.45,19.668 Z M28.95,14.246 L26.95,14.246 L25.95,14.246 L17.975,14.246 L17.975,13.746 L17.975,9.052 C19.463,8.186 20.475,6.592 20.475,4.746 C20.475,2.9 19.463,1.306 17.975,0.44 C17.661,0.257 17.327,0.112 16.975,0 L16.975,1.044 L16.975,3.746 L13.975,3.746 L13.975,1.044 L13.975,0 C13.623,0.112 13.289,0.257 12.975,0.44 C11.487,1.306 10.475,2.9 10.475,4.746 C10.475,6.592 11.487,8.186 12.975,9.052 L12.975,13.746 L12.975,14.246 L4.95,14.246 L3.95,14.953 L0,17.746 L3.95,20.539 L4.95,21.246 L12.975,21.246 L12.975,26.44 C11.487,27.306 10.475,28.9 10.475,30.746 C10.475,32.592 11.487,34.186 12.975,35.052 C13.289,35.235 13.623,35.38 13.975,35.492 L13.975,34.448 L13.975,31.746 L16.975,31.746 L16.975,34.448 L16.975,35.492 C17.327,35.38 17.661,35.235 17.975,35.052 C19.463,34.186 20.475,32.592 20.475,30.746 C20.475,28.9 19.463,27.306 17.975,26.44 L17.975,21.246 L25.95,21.246 L26.95,21.246 L28.95,21.246 C29.502,21.246 29.95,20.798 29.95,20.246 L29.95,15.246 C29.95,14.694 29.502,14.246 28.95,14.246 L28.95,14.246 Z",
    id: "Fill-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.475,11.746 C15.751,11.746 15.975,11.522 15.975,11.246 C15.975,10.97 15.751,10.746 15.475,10.746 C15.199,10.746 14.975,10.97 14.975,11.246 C14.975,11.522 15.199,11.746 15.475,11.746",
    id: "Fill-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.975,24.246 C15.975,23.97 15.751,23.746 15.475,23.746 C15.199,23.746 14.975,23.97 14.975,24.246 C14.975,24.522 15.199,24.746 15.475,24.746 C15.751,24.746 15.975,24.522 15.975,24.246",
    id: "Fill-14"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildCustomWidget);
export default __webpack_public_path__ + "static/media/build-custom-widget.b15f6e381a5ff0d5d11f6e6b725ce285.svg";
export { ForwardRef as ReactComponent };